import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import { Stack, Typography } from '@mui/material';

function FeaturedBannerEmptyState() {
  return (
    <Stack sx={{ height: '50vh', alignItems: 'center', justifyContent: 'center', gap: '1rem' }}>
      <CreateNewFolderIcon sx={{ width: 100, height: 100 }} />
      <Typography variant="h5" sx={{ width: '100%', textAlign: 'center' }}>
        Click "Add New" to add featured banner
      </Typography>
    </Stack>
  );
}

export default FeaturedBannerEmptyState;
